import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { AttachmentService } from 'src/app/service/attachment.service';
import { FreeFormAgendaService } from 'src/app/service/free-form-agenda.service';
import { FreeFormMinutesService } from 'src/app/service/free-form-minutes.service';
import { MeetingService } from 'src/app/service/meeting.service';
import { PermissionService } from 'src/app/service/permission.service';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { UtilityService } from 'src/app/service/utility.service';
import { AddLinkDialogComponent } from '../add-link-dialog/add-link-dialog.component';
import { AttachmentDialogComponent } from '../attachment-dialog/attachment-dialog.component';
declare var CKEDITOR: any;
import { environment_const, meetingTourValues, scheduleMeetingTourValues } from 'src/environments/environment';
import { MinutesCollabDetails } from 'src/app/models/basicMeetingModel';
import { UtcDatePipe } from 'src/app/pipe/UtcDate.pipe';
import { HistoryComponent } from '../history/history.component';
import { HistoryDialogService } from 'src/app/service/history-dialog.service';

@Component({
  selector: 'app-instant-meeting-decision',
  templateUrl: './instant-meeting-decision.component.html',
  styleUrls: ['./instant-meeting-decision.component.css'],
  providers:[UtcDatePipe]
})
export class InstantMeetingDecisionComponent implements OnInit,AfterViewInit {
  //UI Team variable declaration
  collabVariable = 'active'
disaleAttachmentFileIcon: any;
  @Input()hideParts: any
  //padlock variable
  padlock :any;
  matDialogRef!: MatDialogRef<AttachmentDialogComponent>;
  isPrivate: any;
  showToolTip = false;
  agendaAttachResp: any;
  attachCount: boolean =true;
  attachmentCount: any;
  attachmentTotalCnt: any = true;
  attachmentIcon = 'Y';
  @Input() pinDialogTriggered = false;
  @Input() contentEditableBoolmin = false;
  editCollabData = <MinutesCollabDetails>{};
  @Input() meetingResponse:any
  isExtraSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.XSmall
    );
    isMedium: Observable<BreakpointState> = this.breakpointObserver.observe(
      Breakpoints.Medium
    )
    isSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
      Breakpoints.Small
    )
    @Input()videoSectionStatusChecker : any
  disableDecisionIcon: any;

  //property for adding new class for login user is a task user.
  selectedTabName: any;
  padlockDisable:any;

  constructor(private utility:UtilityService,private permissionService:PermissionService,public sideNavService : SideNavServiceService, private readonly breakpointObserver: BreakpointObserver,public meetingService:MeetingService,private dialog: MatDialog, public commonMinService:FreeFormMinutesService,public freeFormAgenda:FreeFormAgendaService,public attachService:AttachmentService,private historyDialogService:HistoryDialogService) {
   }
  @Input() minAttrList:any;

  @Input()
  deviceXs!: boolean;

  @Input()
  deviceSm!: boolean;

  @Input()
  deviceMd! : boolean;

  @Input()
  deviceLg! : boolean;

  @Input()
  deviceXl! : boolean;
  meetingTourValues = meetingTourValues
  scheduleMeetingTourValues = scheduleMeetingTourValues
  @ViewChild('decisionElement') decisionElement!: ElementRef;

  ngOnInit(): void {
    var padLockValue = this.minAttrList.isPrivate;
    if(padLockValue == 'Y'){
      this.padlock = true;
    }else{
      this.padlock = false;
    }
  }
  handleMouseUp(noteElement: HTMLDivElement): void {
    const selection = window.getSelection();
    if (selection && selection.toString()) {
      noteElement.setAttribute('highlightIndex', '0');
    }
  }
handleFocus(event: FocusEvent, noteElement: HTMLDivElement): void {
  this.sideNavService.closeAllAccordtion();
  this.sideNavService.smootherScroll(event.target);
  noteElement.setAttribute('highlightIndex', '0'); 
}

handleKeyDown(event: KeyboardEvent, noteElement: HTMLDivElement): void {
  this.freeFormAgenda.trackChangesWhileEditing(
    noteElement.getAttribute('decisionId')!,
    noteElement.getAttribute('agId')!,
    event,
    noteElement.getAttribute('entityType')!,
    'agMinId' + noteElement.getAttribute('decisionId')
  );
      if (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === 'h') {
      event.preventDefault();
    this.highlightNextText(noteElement);
  }
}

highlightNextText(noteElement: HTMLDivElement): void {
  // const regex = /\[XXXXXX\]/gi;
  const regex = environment_const.patternKey;
  const content = noteElement.textContent || '';
  const matches = Array.from(content.matchAll(regex));
  const count = matches.length;
  if (count === 0) return;

  let currentIndex = parseInt(noteElement.getAttribute('highlightIndex') || '0', 10);
  noteElement.setAttribute('highlightIndex', ((currentIndex + 1) % count).toString());

  this.applyHighlight(noteElement, matches, currentIndex);
}

applyHighlight(noteElement: HTMLDivElement, matches: RegExpMatchArray[], highlightIndex: number): void {
  if (!noteElement.firstChild) return;

  const selection = window.getSelection();
  const range = document.createRange();
  
  const match = matches[highlightIndex];
  if (!match) return;
  const start = match.index!;
  const end = start + match[0].length;


  let offset = 0;
  let found = false;
  const nodes = Array.from(noteElement.childNodes);
  for (const node of nodes) {
    const nodeLength = node.textContent?.length || 0;

    if (offset + nodeLength >= start && !found) {
      const relativeStart = start - offset;
      const relativeEnd = end - offset;
      
      range.setStart(node, relativeStart);
      range.setEnd(node, Math.min(relativeEnd, nodeLength));

      found = true;
      break;
    }

    offset += nodeLength;
  }

  if (found) {
    selection?.removeAllRanges();
    selection?.addRange(range);
  }
}
  ngAfterViewInit() {
    this.commonMinService.activateAllCkeditor('agChildDecision');
    var roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utility.featureList.NOTES,this.utility.permissionType.MODIFY);
    
    
    if(!roleFlag){
      this.disableDecisionIcon = true;
      // $("#insertAttendeeSec").attr('contenteditable', false);
      this.selectedTabName = roleFlag;
    }else{
      this.disableDecisionIcon = false;
    }
    if(this.contentEditableBoolmin == false){
      for(var i = 0; i < document.getElementsByClassName('agChildDecision').length; i++){
        document.getElementsByClassName('agChildDecision')[i].setAttribute('contenteditable','false')
      }
     }
     
       //code added to allow to make private only for created user
    if(this.minAttrList.createdBy==localStorage.getItem("userId")){
      this.padlockDisable=false;
    }else{
      this.padlockDisable=true;
    }
    //close
  }

  getMinComStatusCode(){

    if(this.meetingResponse.commonMomStatusCode == 'A'){
      this.disaleAttachmentFileIcon = true;
    }else{
      this.disaleAttachmentFileIcon = false;
    }
  }

  
  ngOnDestroy(){
    // for (var instance in CKEDITOR.instances) {
    //   CKEDITOR.instances[instance].destroy();
    // }
  }

  //attachment dialog

  openConfidentialDialog(e : any, m : any) {
     let attchDialog =  this.dialog.open(AttachmentDialogComponent,{
      data:{e,m,"data" : this.contentEditableBoolmin,"disaleAttachmentFileIcon":this.disaleAttachmentFileIcon},
      panelClass: ['animate__animated','animate__slideInLeft'],
                  disableClose: true,
                  position : {
                    left : "0%"
                  },
                  maxWidth : "100%",
                  maxHeight: "100vh",
                  width: "50%",
                  height : "100vh"
    })
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if(size.matches){
        attchDialog.updateSize('70vw','100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if(size.matches){
        attchDialog.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        attchDialog.updateSize('100vw', '100vh');
      } 
    });
    attchDialog.afterClosed().subscribe((response: any) => {
      mediumDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
      this.meetingService.fetchDecision(e._id).subscribe((data: any) => {
        
        if (data != undefined) {
          var minAttrList = this.minAttrList;
          if (minAttrList != null) {
           this.minAttrList.attachmentTotalCnt = data.body.attachmentTotalCnt
           this.freeFormAgenda.pushAttachmentCount(this.minAttrList, data.body.attachmentTotalCnt,'MD');
          }
         }
      });

    })
    //
  }

  //agenda link dialog

  addNewLink(entityId:any, meetingId:any) {
    let addLinkDialog = this.dialog.open(AddLinkDialogComponent, {
      data:{entityId,meetingId,"entityType":"MD","attachmentMode":"LI","data" : this.contentEditableBoolmin,"disaleAttachmentFileIcon":this.disaleAttachmentFileIcon},
      panelClass: ['animate__animated','animate__slideInLeft'],
                  disableClose: true,
                  position : {
                    left : "0%"
                  },
                  maxWidth : '100%',
                  maxHeight: "100vh",
                  width: "50%",
                  height : "100vh"
    })
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if(size.matches){
        addLinkDialog.updateSize('70vw','100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if(size.matches){
        addLinkDialog.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        addLinkDialog.updateSize('100vw', '100vh');
      } 
    });
    addLinkDialog.afterClosed().subscribe((response: any) => {
      mediumDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
      this.meetingService.fetchDecision(entityId).subscribe((data: any) => {
        
        if (data != undefined) {
          var minAttrList = this.minAttrList;
          if (minAttrList != null) {
           this.minAttrList.attachmentTotalCnt = data.body.attachmentTotalCnt
           this.freeFormAgenda.pushAttachmentCount(this.minAttrList, data.body.attachmentTotalCnt,'MD');
          }
         }
      });

    })
  }

  trackChanges(id : any){
    this.showToolTip = true;
    //
    let elementCreation = document.getElementById('agMinId'+id);
    $('#agMinId'+id).css("border","5px solid rgba(0,0,0,.12)")
  }

  removeTrackChanges(id : any){
    $('#agMinId'+id).css("border","0px")
    this.showToolTip = false
  }

  statusTracker(id : any, vari : any){
    if(vari == 'active'){
      let element = (<HTMLElement>document.getElementById("agMinId"+id))
      element.contentEditable = 'false'
    }
    else if(vari == 'inActive'){
      let element = (<HTMLElement>document.getElementById("agMinId"+id))
      element.contentEditable = 'true'
    }
  }

  //padlock function
  togglePadLock(e:any) {
    // if((e.target.textContent).trim() == "lock_open"){
    //   this.isPrivate = "Y";
    //  }
    //  else{
    //    this.isPrivate = "N";
    //  }
    this.padlock = !this.padlock;
      this.isPrivate = this.padlock ? 'Y' : 'N';

    var data={}
    var decisionJson={
    "isPrivate":  this.isPrivate,
    "agendaId": this.minAttrList.agendaId,
    "meetingId": this.minAttrList.meetingId,
    "entityType": this.minAttrList.entityType,
    "minutesId": this.minAttrList.decisionId,
    "noteTypeCode": this.minAttrList.noteTypeCode,
    "decisionId": this.minAttrList.decisionId
    }
   var saveUrl = this.freeFormAgenda.getSaveUrl ("Y",this.minAttrList.entityType,decisionJson);
   this.freeFormAgenda.saveMinutesAttributes(data, decisionJson, saveUrl, "Y") .then((result: any) => {
                Object.assign(this.minAttrList, result);

    if(this.isPrivate == 'Y'){
       this.editCollabData.elementId= this.minAttrList.decisionId;
       this.editCollabData.agElementId=this.minAttrList.agendaId;
       this.editCollabData.meetingId=this.minAttrList.meetingId;
       this.editCollabData.collabType='MINPRIVATE'
   }else{
     this.meetingResponse.agendaList.forEach((agElem: any, agIndex: any) => {
       
       if (agElem.agendaId == this.minAttrList.agendaId) {
         
         this.editCollabData.agElemPosition=agIndex;
         
          if (agElem.minutesList != null && agElem.minutesList != undefined) {
           agElem.minutesList.forEach((minElem: any, minIndex: any) => {
             
             if ((minElem.decisionId != null && minElem.decisionId == this.minAttrList.decisionId)) {
               
             this.editCollabData.minElemPosition = minIndex;
             }
           });
         }
       }
     });
     this.editCollabData.elementVal=this.minAttrList;
     this.editCollabData.collabType='MIN';
     this.editCollabData.elementId=this.minAttrList.decisionId;
     this.editCollabData.meetingId=this.minAttrList.meetingId;
    }
    this.freeFormAgenda.callPushMessageToServer(this.editCollabData,'','');

  });
  }

  toggleResPadLock(e:any) {
    // if((e.target.textContent).trim() == "lock_open private" || (e.target.textContent).trim() == "lock_open"){
    //  this.isPrivate = "Y";
    // }
    // else{
    //   this.isPrivate = "N";
    // }
    this.padlock = !this.padlock;
      this.isPrivate = this.padlock ? 'Y' : 'N';

    var data={}
    var decisionJson={
      "isPrivate":  this.isPrivate,
      "agendaId": this.minAttrList.agendaId,
      "meetingId": this.minAttrList.meetingId,
      "entityType": this.minAttrList.entityType,
      "minutesId": this.minAttrList.decisionId,
      "noteTypeCode": this.minAttrList.noteTypeCode,
      "decisionId": this.minAttrList.decisionId
    }
   var saveUrl = this.freeFormAgenda.getSaveUrl ("Y",this.minAttrList.entityType,decisionJson);
   this.freeFormAgenda.saveMinutesAttributes(data, decisionJson, saveUrl, "Y")
  }
  
  getAttachCount(e:any){
     this.meetingService.fetchDecision(e.decisionId).subscribe((data: any) => { 
      this.agendaAttachResp = data.body;
      this.attachCount = false;
   });  
  }

//   ngOnChanges(event : any){
//     

//     let idReference = 'agMinId'+this.minAttrList.decisionId
//     let agMinId = (<HTMLElement>document.getElementById('agMinId'+this.minAttrList.decisionId));

//     // (<HTMLElement>document.getElementById('agMinId'+event.collbElementId.currentValue)).addEventListener('keyup', (e : any) => {
//     
//     
//     // })
    
//     
//     // if(this.minAttrList.rowStatus != undefined || this.minAttrList.rowStatus != null){
//     //   let noteIdAccess = (<HTMLElement>document.getElementById('agMinId'+event.collbElementId.currentValue))
//     //     noteIdAccess.title = this.minAttrList.rowStatus
//     // }
//     // let noteId = document.getElementById(event)
//     
//     
//     
//     
//     function getCaretCoordinates() {
//       let x = 0,
//         y = 0;
//       const isSupported = typeof window.getSelection !== "undefined";
//       if (isSupported) {
//         const selection = window.getSelection();
//         if (selection!.rangeCount !== 0) {
//           const range = selection!.getRangeAt(0).cloneRange();
//           range.collapse(true);
//           const rect = range.getClientRects()[0];
//           if (rect) {
//             x = rect.left;
//             y = rect.top;
//           }
//         }
//       }
//       return { x, y };
//     }
    
//     function toggleTooltip(event: { target: any; }, contenteditable: { contains: (arg0: any) => any; }) {
//       // window.alert("calledddddd")
//       if(event.target.id == idReference){
//         // window.alert("code triggered")
//         const tooltip = document.getElementById("decision-tooltip");

//         if (contenteditable.contains(event.target)) {
//           // window.alert("called")
//           const { x, y } = getCaretCoordinates();

//           tooltip!.setAttribute("aria-hidden", "false");
//           tooltip!.setAttribute(
//             "style",
//             `display: inline-block;
//             position : absolute; 
//             left: ${x - 132}px;
//             top: ${y - 390}px`
//           );
//         } 
//         else {
//           tooltip!.setAttribute("aria-hidden", "true");
//           tooltip!.setAttribute("style", "display: none;");
//         }
//       }


      
//     }

//     window.addEventListener("click", (e) => toggleTooltip(e, agMinId));
//     //window.addEventListener("focus", (e) => toggleTooltip(e, agMinId))
// //window.addEventListener("blur", (e) => toggleTooltip(e, agMinId))
//     window.addEventListener("keyup", (e) => toggleTooltip(e, agMinId));
    
//   }
  
createEmptyAgenda(event:any){
  
  var roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utility.featureList.AGENDA,this.utility.permissionType.MODIFY);
          
          if(!roleFlag){
            return
          }
  var newAg='AG'
  this.freeFormAgenda.trackAgendaEventOnClick(event,newAg);

}

createEmptyNote(event:any){
  
  var roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utility.featureList.NOTES,this.utility.permissionType.MODIFY);
          
          if(!roleFlag){
            return
          }
  var entityType="/nn";
  this.freeFormAgenda.trackAgendaEventOnClick(event,entityType);

}

createEmptyTask(event:any){
  
  var roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utility.featureList.TASK,this.utility.permissionType.MODIFY);
          
          if(!roleFlag){
            return
          }
  var entityType="/tt";
  this.freeFormAgenda.trackAgendaEventOnClick(event,entityType);

}

createEmptyDecision(event:any){
  
  var roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utility.featureList.NOTES,this.utility.permissionType.MODIFY);
          
          if(!roleFlag){
            return
          }
  var entityType="/dd";
  this.freeFormAgenda.trackAgendaEventOnClick(event,entityType);

}

history(entityId:any,modifiedName:any) {

  var entityType ='MD';
  this.historyDialogService.openHistoryDialog(entityId,entityType, modifiedName, this.isMedium, this.isSmall, this.isExtraSmall);
}
blur(target:any,event:any){
  var selectTextAsDecision = (event.altKey  &&  (event.keyCode == 78 || event.keyCode == 68 || event.keyCode == 84));//(ALT+N)
  if(selectTextAsDecision){
  this.commonMinService.triggerSaveMinutes(target,event);
  }
}

}
